.circular-data-widget {
  background-color: white;
  padding: 30px 30px;
  border-radius: 12px;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
  height: 100%;
  font-family: 'Lato';
  font-weight: 400;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-title {
  text-align: center;
}

.card-description {
  text-align: center;
  margin-bottom: 12px;
}
